import { KEYS_GENERATE } from "constants/securityConst";
import { decodeData, encodeData } from "./fernet";

/**
 * Retrieves and parses a value from localStorage.
 * This function takes a key, retrieves the corresponding value from `localStorage`, and parses it from a JSON string
 * into a JavaScript object. If the key does not exist in `localStorage` or if the stored value is not valid JSON,
 * this function will return `null`.
 * @param {string} key - The key under which the value is stored in `localStorage`.
 * @returns {*} The parsed JavaScript object stored under the specified key, or `null` if the key does not exist
 * or if the value cannot be parsed.
 */
export const getItemLocalStorage = (key) => {
  return decodeData(window.localStorage.getItem(KEYS_GENERATE[key]));
};

/**
 * Stores a value in localStorage as a JSON string.
 * This function takes a key and a data value, converts the data to a JSON string, and stores it in `localStorage`
 * under the specified key. If the storage operation is successful, the function returns `undefined` (since `localStorage.setItem` does not return a value).
 * @param {string} key - The key under which the value should be stored in `localStorage`.
 * @param {*} data - The data to store. This can be any JavaScript object or value that can be converted to JSON.
 * @returns {void} This function does not return any value.
 */
export const setItemLocalStorage = (key, data) => {
  return window.localStorage.setItem(KEYS_GENERATE[key], encodeData(data));
};
